// LLM generated - Model Claude 4 Sonnet
import React from 'react';
import { Box } from '@mantine/core';
import { IconArrowRight } from '~/domains/design-system/icons/IconArrowRight';
import RYPBadge from '~/domains/design-system/badges/RYPBadge/RYPBadge';
import OFPBadge from '~/domains/design-system/badges/OFPBadge/OFPBadge';
import SplashBadge from '~/domains/design-system/badges/SplashBadge/SplashBadge';
import { BRANDS } from '~/domains/auth/consts';

import useStyles from './BrandBadges.styles';

type BrandBadgesProps = {
  brand: BRANDS;
  className?: string;
};

export function BrandBadges({ brand, className }: BrandBadgesProps) {
  const { classes } = useStyles();

  const renderBadges = () => {
    switch (brand) {
      case BRANDS.RYP:
        return (
          <div className={classes.brandBadgesContainer}>
            <RYPBadge width={80} height={80} />
            <SplashBadge
              iconColor="#101113"
              width={80}
              height={80}
              className={classes.splashBadge}
            />
            <Box className={classes.arrowCircle}>
              <IconArrowRight color="#1A1C1E" size={21} />
            </Box>
          </div>
        );

      case BRANDS.OFP:
        return (
          <div className={classes.brandBadgesContainer}>
            <OFPBadge width={80} height={80} />
            <SplashBadge
              iconColor="#101113"
              width={80}
              height={80}
              className={classes.splashBadge}
            />
            <Box className={classes.arrowCircle}>
              <IconArrowRight color="#1A1C1E" size={21} />
            </Box>
          </div>
        );

      default:
        return null;
    }
  };

  return <div className={className}>{renderBadges()}</div>;
}
